export { default } from "./UserList";



// WEBPACK FOOTER //
// ./src/components/UserList/index.ts